import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import createIcon from "../assets/images/icons/create.png";
import deleteIcon from "../assets/images/icons/delete.png";

export default class DemoDataList extends React.Component {

  async handleOpenUpdateDemoDataFormDialog(demoData) {
    this.props.openDemoDataFormDialog(demoData);
  }

  async handleOpenDemoDataDeleteWarningDialog(demoData) {
    this.props.openDemoDataDeleteWarningDialog(demoData)
  }

  render() {
    const {
      classes,
      demoDataList
    } = this.props;

    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>AssetID</TableCell>
              <TableCell align="right">Production type</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {demoDataList.length < 1 && 
            <TableRow key="No data">
              <TableCell component="th" scope="row">
                  No demo data yet
                </TableCell>
            </TableRow>
            }
            {demoDataList.map(demoData => (
              <TableRow key={demoData.assetID}>
                <TableCell component="th" scope="row">
                  {demoData.assetID}
                </TableCell>
                <TableCell align="right">
                  {demoData.production_type}
                </TableCell>
                <TableCell align="right">
                  <Button
                    onClick={event => {
                      this.handleOpenUpdateDemoDataFormDialog(demoData);
                    }}
                  >
                    <img
                      src={createIcon}
                      alt={"Update demo data"}
                      title={"Update demo data"}
                      style={{ width: 24, height: 24 }}
                    />
                  </Button>
                  <Button
                    onClick={event => {
                      this.handleOpenDemoDataDeleteWarningDialog(demoData);
                    }}
                  >
                    <img
                      src={deleteIcon}
                      alt={"Delete demo data"}
                      title={"Delete demo data"}
                      style={{ width: 24, height: 24 }}
                    />
                  </Button>
                </TableCell>
                


                



              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  }
  
}


// WEBPACK FOOTER //
// ./src/components/DemoDataList.js